import React from "react";
import PropTypes from "prop-types";

export default function Main({
  title,
  header,
  children,
  className,
  innerClassName,
}) {
  return (
    <div
      className={`md:rounded-xl md:border-0.5 border-stone-400 flex flex-col overflow-y-hidden ${className || "flex-1"}`}
    >
      <div
        className={`bg-white rounded-xl flex-1 flex flex-col overflow-y-auto ${innerClassName || "p-5"}`}
      >
        <div className="flex flex-row mb-6 justify-between items-center gap-8">
          {title && (
            <h1 className="font-semibold text-base  md:text-2xl text-Bleu-fonc-Soregies">
              {title}
            </h1>
          )}
          {header && <div>{header}</div>}
        </div>
        {children}
      </div>
    </div>
  );
}

Main.propTypes = {
  title: PropTypes.any,
  header: PropTypes.any,
  children: PropTypes.any,
  className: PropTypes.string,
  innerClassName: PropTypes.string,
};
